import type { ElementType, JSX, PropsWithChildren } from 'react';

import classNames from 'classnames';

import styles from './Heading.module.css';

interface HeadingProps<T> {
  level?: 1 | 2 | 3 | 4 | 5 | 6 | 7;
  as?: T;
  id?: string;
}

function Heading<T extends ElementType>({
  level = 1,
  as,
  children,
  ...props
}: PropsWithChildren<HeadingProps<T>>): JSX.Element {
  const Component: ElementType = as ?? (level === 7 ? 'p' : `h${level}`);
  const className = styles[`Heading${level}`];

  return (
    <Component className={classNames(styles.Heading, className)} {...props}>
      {children}
    </Component>
  );
}

export default Heading;
